import { sap2Society, sap2Division, sap2ClaimingArea, sap2AccountingKey } from "./sap-mapper";

export const toFormattedNumber = (toParse, decimals = 2) => {
  const number = parseFloat(toParse);
  const parsed = !Number.isNaN(number)
    ? number
        .toFixed(decimals) // always three decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        .replace(`,${"0".repeat(decimals)}`, "") // clear empty decimals
    : toParse;
  return parsed;
};

export const toHibridSocietyFormat = society => {
  const result = Object.entries(sap2Society).find(entry => entry[0] === society);
  return result ? `${result[0]}: ${result[1]}` : society;
};

export const toHibridDivisionFormat = division => {
  const result = Object.entries(sap2Division).find(entry => entry[0] === division);
  return result ? `${result[0]}: ${result[1]}` : division;
};

export const toHibridClaimAreaFormat = (society, claimArea) => {
  const result = Object.entries(sap2ClaimingArea(society)).find(entry => entry[0] === claimArea);
  return result && claimArea && claimArea !== "NO" ? `${result[0]}: ${result[1]}` : claimArea;
};

export const toHibridAccountingkeyFormat = accountingKey => {
  const result = Object.entries(sap2AccountingKey).find(entry => entry[0] === accountingKey);
  return result ? `${result[0]}: ${result[1]}` : accountingKey;
};

export const toFormattedDate = date => {
  const result = date ? date.split("-") : undefined;
  if (result && result.length === 3) return `${result[2]}-${result[1]}-${result[0]}`;
  return "";
};

export default {
  toFormattedNumber,
  toHibridSocietyFormat,
  toHibridDivisionFormat,
  toHibridAccountingkeyFormat,
  toFormattedDate
};
